import React from "react";
import _ from "lodash";

import { Checkbox, Form, Header } from "semantic-ui-react";
import ColorPicker from "../shared/colorPicker";
import NewFontSelector from "../shared/newFontSelector";

import css from "../../assets/styles/shared/editor.module.scss";
import pollsCss from "../../assets/styles/polls/polls.module.scss";
import browserFonts from "../../assets/fonts/browserSafeOption";

export const PollCustomization = ({ draft, setDraft, handleDraftChange }) => {
  const handleChangeValue = (key) => (value) => {
    setDraft((prevDraft) => _.set(_.cloneDeep(prevDraft), key, value));
  };

  const renderColorPicker = (key, alignment, defaultColor, customLabel) => {
    const currentColor = _.get(draft, key, defaultColor) || defaultColor;
    const formattedColor = `#${currentColor}`;

    return (
      <div className={pollsCss.colorPickerSectionStyle}>
        <label className={pollsCss.labelStyle}>
          {customLabel ||
            _.upperFirst(
              key
                .split(".")
                .pop()
                .replace(/([A-Z])/g, " $1")
            )}
        </label>
        <div style={{ display: "flex", gap: "10px" }}>
          <ColorPicker
            __id={"test" + key}
            color={currentColor}
            label={
              customLabel ||
              _.upperFirst(
                key
                  .split(".")
                  .pop()
                  .replace(/([A-Z])/g, " $1")
              )
            }
            orientation="vertical"
            alignment={alignment}
            renderAbove
            handleChangeColor={handleChangeValue(key)}
          />
          <div className={pollsCss.colorBoxStyle}>
            <label htmlFor={"test" + key}>{formattedColor}</label>
          </div>
        </div>
      </div>
    );
  };

  const renderFontSelector = (key, subKey = "font", label = "Font") => {
    const currentFont = _.get(
      draft,
      ["data", "template_data", "customization", key, subKey],
      "Default Font"
    );

    return (
      <div style={{ marginTop: "10px" }} className={css.section}>
        <h5 style={{ fontSize: "13px" }}>{label}</h5>
        <NewFontSelector
          fontName={currentFont}
          updateInBackend={handleChangeValue([
            "data",
            "template_data",
            "customization",
            key,
            subKey,
          ])}
          fromEditor={true}
          browserFonts={browserFonts}
        />
      </div>
    );
  };

  const renderDropdown = ({ label, options, value, keyPath }) => (
    <>
      <Header as="h4" className={pollsCss.labels}>
        {label}
      </Header>
      <Form.Dropdown
        fluid
        selection
        options={options}
        placeholder={label}
        onChange={(e, { value }) => handleDraftChange(keyPath, value)}
        value={value}
      />
    </>
  );

  const renderPollsCustomization = () => (
    <div style={{ marginTop: "20px" }}>
      {draft.data.poll_type === "multiple-choice" &&
        draft?.data?.template_data?.variant === "gif" && (
          <>
            <Header as="h4" className={pollsCss.lableHeading}>
              Answer choices
            </Header>
            <div style={{ marginTop: "15px" }}>
              <Checkbox
                toggle
                label={"Make text values visible for the user"}
                onChange={() =>
                  handleDraftChange(
                    "data.template_data.gifLableVisible",
                    !draft.data.template_data.gifLableVisible
                  )
                }
                checked={draft.data.template_data.gifLableVisible}
              />
            </div>
          </>
        )}
      <Header as="h4" className={pollsCss.lableHeading}>
        General
      </Header>
      {renderDropdown({
        label: "Size",
        options: [
          { text: "X-Small", value: "0.8" },
          { text: "Small", value: "1" },
          { text: "Medium", value: "1.2" },
          { text: "Large", value: "1.3" },
          { text: "X-Large", value: "1.5" },
        ],
        value: draft.data.template_data.customization.general.size,
        keyPath: "data.template_data.customization.general.size",
      })}
      {renderDropdown({
        label: "Alignment",
        options: [
          { text: "Left", value: "left" },
          { text: "Center", value: "center" },
          { text: "Right", value: "right" },
        ],
        value: draft.data.template_data.customization.general.alignment,
        keyPath: "data.template_data.customization.general.alignment",
      })}
      {renderColorPicker(
        "data.template_data.customization.general.bodyBackgroundColor",
        "center",
        "ffffff",
        "Background Color"
      )}
      <Header as="h4" className={pollsCss.lableHeading}>
        Question Customization
      </Header>
      {renderFontSelector("question", "font", "Font")}
      {renderColorPicker(
        "data.template_data.customization.question.text",
        "center",
        "000000",
        "Font Color"
      )}
      {renderColorPicker(
        "data.template_data.customization.question.questionBackground",
        "center",
        "ffffff",
        "Background Color"
      )}
      <Header as="h4" className={pollsCss.lableHeading}>
        Answer Customization
      </Header>
      {renderFontSelector("answer", "font", "Font")}
      {renderColorPicker(
        "data.template_data.customization.answer.text",
        "center",
        "000000",
        "Font Color"
      )}
      {renderColorPicker(
        "data.template_data.customization.answer.questionBackground",
        "center",
        "ffffff",
        "Background Color"
      )}
      {renderColorPicker(
        "data.template_data.customization.answer.border",
        "center",
        "0044C3",
        "Border Color"
      )}
    </div>
  );

  return <>{renderPollsCustomization()}</>;
};
